import React from "react";
import { Link } from "react-scroll";
import "./Banner.scss";
import BannerImg from "../../../assets/banner-img.png";

const Banner = () => {
  return (
    <div className="hero-banner">
      <div className="overlay"></div>
      <div className="content">
        {/* <img className="banner-img" src={BannerImg} /> */}
        <div className="text-content">
          <h1>Pinch Harmonic Guitars</h1>
          <p>Elevate your sound with our premium guitar selection</p>
          <div className="ctas">
            <Link to="main-container" smooth={true} duration={500} offset={-80}>
              <div className="banner-cta v2">Shop Now</div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
